import { Box, Typography } from '@mui/material';
import { AssetType, UntrackedAssetType } from '@peritasai/types';
import React from 'react';
import { AssetRow } from './AssetRow';
import type { PreferenceCardItem } from './preference-card.types';

export interface ItemGroupListProps {
  items: PreferenceCardItem[];
  groups: { type: AssetType | UntrackedAssetType; label: string }[];
  onQuantityChange: (id: string, delta: number) => void;
  onNoteClick: (id: string, note: string) => void;
  onDelete: (id: string) => void;
}

export const ItemGroupList: React.FC<ItemGroupListProps> = ({ items, groups, onQuantityChange, onNoteClick, onDelete }) => (
  <>
    {groups.map(({ type, label }) => {
      const groupItems = items.filter((i) => i.type === type);
      if (groupItems.length === 0) return null;
      return (
        <Box key={type}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
            <Typography variant="caption" color="text.secondary" sx={{ whiteSpace: 'nowrap' }}>
              {label}
            </Typography>
            <Box sx={{ flex: 1, height: '1px', bgcolor: 'divider' }} />
          </Box>
          {groupItems.map((item) => (
            <AssetRow
              key={item.catalogItemId}
              item={item}
              onQuantityChange={onQuantityChange}
              onNoteClick={onNoteClick}
              onDelete={onDelete}
            />
          ))}
        </Box>
      );
    })}
  </>
);
